import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BBadge = _resolveComponent("BBadge")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BNav = _resolveComponent("BNav")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BNav, {
      fill: "",
      class: "applications-nav"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `link-${index}`,
            class: _normalizeClass([{ 'has-count': link.count }, "applications-nav-item"])
          }, [
            _createVNode(_component_RouterLink, {
              to: { name: 'ApplicationsList', query: { tab: link.tab } },
              class: "applications-nav-link",
              "exact-active-class": _ctx.isCurrentTab(link.tab) ? 'active' : ''
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.title) + " ", 1),
                (link.count > 0)
                  ? (_openBlock(), _createBlock(_component_BBadge, {
                      key: 0,
                      pill: "",
                      variant: "red",
                      class: "number-badge"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.count), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 2
            }, 1032, ["to", "exact-active-class"])
          ], 2))
        }), 128))
      ], undefined, true),
      _: 1
    })
  ]))
}